export const AuditLogEventPayload = ({ data, dark = false }) => {
  const baseStyle =
    "overflow-x-auto rounded-lg p-6 text-base leading-relaxed break-words whitespace-pre-wrap";

  const colorStyle = dark ? " bg-black text-white" : " bg-gray-100";

  const cssClasses = baseStyle + colorStyle;

  return (
    <pre className={cssClasses}>
      {JSON.stringify(JSON.parse(data), null, 4)}
    </pre>
  );
};
